import ApiHandler from "./ApiHandler";

const Variant = {
  add: async (data, options) => await ApiHandler.i.auth().post('/variant', data, options),
  deleteOne: async (variantId) => await ApiHandler.i.auth().delete(`/variant/${variantId}`),
  findAll: async (query) => await ApiHandler.i.auth().get(`/variant?${query.toString()}`),
  findOne: async (query) => await ApiHandler.i.auth().get(`/variant/find?${query.toString()}`),
  getOne: async (variantId) => await ApiHandler.i.auth().get(`/variant/${variantId}`),
};

export default Variant;